/* eslint-disable eslint-comments/disable-enable-pair -- remove warning */
/* eslint-disable @typescript-eslint/no-explicit-any -- remove warning */
/* eslint-disable react/boolean-prop-naming -- remove warning */
/* eslint-disable complexity -- remove warning */
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  CallToAction, Layout,
  Heading, Button,
} from '@americanexpress/dls-react';
import { generateUrls } from '@americanexpress/axp-benefits-utils';
import { Link } from '@americanexpress/one-app-router';
import { IconWarning } from '@americanexpress/dls-icons';
import { useModule } from '@americanexpress/holocron-hooks';
import style from './detail-page.css';
import TermsModal from '../TermsModal';
import { renderHtml } from './utils/render-html';
import { Normalize } from './typings/normalize';
import EnrollStatus from './enrollstatus/EnrollStatus';
import { ctaProtocolCheck } from './utils';
import AnalyticsClick from '../../../shared/components/analyticsClick';
import WarningModal from '../../../detail/components/WarningModal';

interface Props {
  benefit: Normalize,
  benefitsData: any,
  cardname: string,
  imageUrl: string,
  showTerms: boolean,
  env: string,
  login: boolean,
  showDisclosures: boolean,
  disclosureHeading: string,
  disclosureDescription: string,
  localeDetails: string,
  resyModuleProps?: Normalize,
  runBenefits?: () => void,
  refreshBenefitsData?: (newBenefitsData: any) => void
}

function DetailPageTile(props: Props): JSX.Element {
  const cardname = props?.cardname;
  const benefitsData = props?.benefitsData;
  const benefit = props?.benefit;
  const showTerms = props?.showTerms;
  const showDisclosures = props?.showDisclosures;
  const title = benefit?.title;
  const localeDetails = props?.localeDetails;
  const [showWarningModal, setShowWarningModal] = useState(false);

  const detail = benefit?.detail;
  const image = detail?.image?.startsWith('http://') || detail?.image?.startsWith('https://')
    ? detail?.image : `${props?.imageUrl}${detail?.image}`;
  const copy = detail?.copy;
  const rejectedMessage = detail?.status?.enrollmentApplication?.rejectedMessage;

  const showStatus = detail?.status?.enabled;
  const statusLabel = detail?.status?.label;
  const enrollmentApplicationStatus = detail?.status?.enrollmentApplication.status;

  const showLearnMore = detail?.learnMoreCTA.enabled;
  const learnMoreLabel = detail?.learnMoreCTA?.label;
  const learnMoreHref = detail?.learnMoreCTA?.link;

  const showEnroll = detail?.enrollCTA.enabled;
  const enrollLabel = detail?.enrollCTA?.label;

  // If not logged in force to login page for enroll href
  const isAuthenticated = Boolean(props?.login);
  const showResy = props?.benefit?.enrollment?.enrollType === 'PARTNER-LINKING';

  // eslint-disable-next-line unicorn/consistent-function-scoping
  const parseEntities = (txt) => new DOMParser().parseFromString(txt, 'text/html').body.textContent;

  let ENROLL_PAGE = '';
  if (global.BROWSER) {
    ENROLL_PAGE = encodeURIComponent(`${window?.location?.origin}${detail?.enrollCTA?.link}`);
  }

  const enrollHref = !isAuthenticated
    ? `${generateUrls(props?.env).MYCA_LOGIN_URL}${ENROLL_PAGE}`
    : global.BROWSER && `${window?.location?.origin}${detail?.enrollCTA?.link}`;

  const showExternal = detail?.externalCTA?.enabled;
  const externalLabel = detail?.externalCTA.label;
  const externalHref = detail?.externalCTA?.link;

  const disclosureHeading = props?.disclosureHeading;
  const disclosureDescription = props?.disclosureDescription;

  const [isOpen, setIsOpen] = useState(false);
  const { Module: TaskFlowModal } = useModule('axp-task-flow-wrapper');
  const { Module: ResyLinking } = useModule('axp-resy-linking');
  const locale = props?.localeDetails || 'en-US'; // fallback if not present
  // Placeholder: You may need to pass these as props or fetch from context
  const resyModuleProps = props?.resyModuleProps || {};
  const runBenefits = props?.runBenefits;
  const refreshBenefitsData = props?.refreshBenefitsData;
  const onClose = () => setIsOpen(false);
  const onSubmit = () => {
    runBenefits();
    refreshBenefitsData(benefitsData);
    setIsOpen(false);
  };

  // Extract TaskFlowModal and ResyLinking into a function
  function showResyLinkWrapper() {
    return (
      <TaskFlowModal
        variant="modal"
        isOpen={isOpen}
        onClose={onClose}
        title="resy-linking"
      >
        <ResyLinking
          locale={locale}
          benefitData={resyModuleProps}
          onClose={onClose}
          onSubmit={onSubmit}
        />
      </TaskFlowModal>
    );
  }

  return (
    <Layout>
      <div className="col-md-12  margin-auto pad-0">
        <div>
          <img
            src={image}
            alt=""
            aria-hidden={true}
            tabIndex={-1}
            className="width-auto height-auto width-full valign-middle"
          />
        </div>

        {rejectedMessage ? (
          <div className="pad-3-lg-up pad-2 body-small">
            <IconWarning size="sm" isFilled={true} color="critical">{rejectedMessage}</IconWarning>
          </div>
        )
          : showStatus && (
            <div className="pad-3-lr-lg-up pad-2-lr pad-3-t-lg-up pad-2-t body-small">
              <EnrollStatus
                labelClass="pad-1-l"
                label={statusLabel}
                enrollmentApplicationStatus={enrollmentApplicationStatus}
                enrolledStatus="true"
              />
            </div>
          )}

        <div className={`pad-3-lg-up pad-2 body-small ${style.card}`}>
          {renderHtml(copy)}
        </div>

        {showLearnMore && global.BROWSER && (
          <div className="pad-3-lr-lg-up pad-3-b-lg-up pad-2-lr pad-2-b">
            <div className="flex flex-justify-center flex-align-center">
              <AnalyticsClick element={`cta>>${cardname?.replace(/ /g, '-').toLowerCase()}>>${learnMoreLabel?.replace(/ /g, '-').toLowerCase()}>>details`} benefitNameTag={parseEntities(title)?.replace(/ /g, '-').toLowerCase()}>
                <CallToAction asChild={true}>
                  <Link
                    to={`${window.location.origin + learnMoreHref}`}
                    className="display-block width-full fluid-xs-down flex-align-center"
                    aria-label={parseEntities(`${`${learnMoreLabel} ${title}`}`)}
                  >
                    <FormattedMessage id={learnMoreLabel} />
                  </Link>
                </CallToAction>
              </AnalyticsClick>
            </div>
          </div>
        )}
        {showEnroll && (
          <div className="pad-3-lr-lg-up pad-3-b-lg-up pad-2-lr pad-2-b">
            <div className="flex flex-justify-center flex-align-center">
              {isAuthenticated ? (
                <>
                  <AnalyticsClick element={`cta>>${cardname?.replace(/ /g, '-').toLowerCase()}>>${enrollLabel?.replace(/ /g, '-').toLowerCase()}>>details`} benefitNameTag={parseEntities(title)?.replace(/ /g, '-').toLowerCase()}>
                    <CallToAction asChild={true}>
                      {showResy ? (
                        <button
                          type="button"
                          className="display-block width-full fluid-xs-down flex-align-center"
                          aria-label={parseEntities(`${`${enrollLabel} ${title}`}`)}
                          onClick={() => setIsOpen(true)}
                          data-testid="open-resy-modal"
                        >
                          <FormattedMessage id={enrollLabel} />
                        </button>
                      ) : (
                        <Link
                          to={enrollHref}
                          className="display-block width-full fluid-xs-down flex-align-center"
                          aria-label={parseEntities(`${`${enrollLabel} ${title}`}`)}
                          data-testid="open-enroll-page"
                        >
                          <FormattedMessage id={enrollLabel} />
                        </Link>
                      )}
                    </CallToAction>
                  </AnalyticsClick>
                  {TaskFlowModal && ResyLinking && isOpen && showResy && showResyLinkWrapper()}
                </>
              ) : (
                <AnalyticsClick element={`cta>>${cardname?.replace(/ /g, '-').toLowerCase()}>>${enrollLabel?.replace(/ /g, '-').toLowerCase()}>>details`} benefitNameTag={parseEntities(title)?.replace(/ /g, '-').toLowerCase()}>
                  <CallToAction
                    className="display-block width-full fluid-xs-down flex-align-center"
                    href={enrollHref}
                    rel="noreferrer"
                    aria-label={parseEntities(`${`${enrollLabel} ${title}`}`)}
                  >
                    <FormattedMessage id={enrollLabel} />
                  </CallToAction>
                </AnalyticsClick>
              )}
            </div>
          </div>
        )}
        {showExternal && (
          <div className="pad-3-lr-lg-up pad-3-b-lg-up pad-2-lr pad-2-b">
            <div className="flex flex-justify-center flex-align-center">
              <AnalyticsClick element={`cta>>${cardname?.replace(/ /g, '-').toLowerCase()}>>${enrollLabel?.replace(/ /g, '-').toLowerCase()}>>details`} benefitNameTag={parseEntities(title)?.replace(/ /g, '-').toLowerCase()}>
                {locale === 'en-CA' || locale === 'fr-CA' ? (
                  <div className="flex width-full flex-justify-center flex-align-center fluid-xs-down">
                    <Button
                      onClick={() => setShowWarningModal(true)}
                      className="display-block width-full fluid-xs-down flex-align-center"
                      aria-label={parseEntities(`${`${externalLabel} ${title}`}`)}
                      data-testid="external-link"
                    >
                      {externalLabel}
                    </Button>
                  </div>
                ) : (
                  <CallToAction
                    className="display-block width-full fluid-xs-down flex-align-center"
                    href={externalHref}
                    rel="noreferrer"  
                    aria-label={parseEntities(`${`${externalLabel} ${title}`}`)}
                  >
                    {renderHtml(externalLabel)}
                  </CallToAction>
                )}
              </AnalyticsClick>
            </div>
          </div>
        )}
        {showDisclosures && (
          <div className="pad-3-lr-lg-up pad-3-b-lg-up pad-2-lr pad-2-b ">
            <hr />
            <Heading level={3} variant="sans-medium-regular" className="margin-2-tb">
              {typeof disclosureHeading === 'string' && disclosureHeading.includes('Amex Assurance Disclosures') ? (
                <FormattedMessage id="shared.terms-links.disclosures" defaultMessage="AMEX Assurance Company Disclosures" />
              ) : null}
            </Heading>
            <div>
              <div className={`border-0 legal-1 ${style.card}`}>
                {renderHtml(disclosureDescription)}
              </div>
            </div>
          </div>
        )}
        {showTerms && (
          <div className="flex flex-wrap pad-3-lg-up pad-2">
            <TermsModal cardname={cardname} localeDetails={localeDetails} />
          </div>
        )}
      </div>
      {showWarningModal && (
      <WarningModal open={showWarningModal} externalLink={externalHref} handleClose={() => setShowWarningModal(false)} warningMessage="You are about to enter a third-party website where all use is governed by that website's Terms and Conditions and subject to its Privacy and Security policies and practices." />
      )}
    </Layout>
  );
}
export const ComponentUnderTest = DetailPageTile;
export default DetailPageTile;
